<div class="background">
  <div class="successMessage alert-dismissible">

    <div class="successMessage alert-dismissible">
      <div *ngIf="warningMessage" class="alert alert-warning scrollBar" role="alert" style="--bs-alert-padding-x: 0.5rem; --bs-alert-padding-y: 0.5rem;">
        <pre style="margin-top: 0.5rem; margin-bottom: 0.5rem;" class="fontStyle">{{ warningMessage }}</pre>
        <button type="button" class="btn-close" (click)="removeMessage()" data-bs-dismiss="alert"
          aria-label="Close" style="padding: 1rem 1rem;"></button>
      </div>

      <div *ngIf="successMessage" class="alert alert-success" role="alert">
        <pre style="margin-top: 0rem; margin-bottom: 0rem;" class="fontStyle">{{ successMessage }}</pre>
        <button type="button" class="btn-close" (click)="removeMessage()" data-bs-dismiss="alert"
          aria-label="Close"></button>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="d-flex flex-row">
      <div class="p-2 flex-grow-1">
        <h2 class="heading">View Parts Count</h2>
      </div>
      <div class="p-2"  *ngIf="showDownloadUploadButtons">
        <!-- <div class="p-2" *ngIf="showDownloadUploadButtons"> -->
        <button
        *ngIf="accessEdit"
          type="button"
          class="btn btn-light"
          (click)="download()"
        >
          <img
            *ngIf="accessEdit"
            src="./assets/images/Group 115533.png"
            class="downloadIcon"
            alt="download icon"
          />
          TEMPLATE
        </button>
      </div>
      <div class="p-2"  *ngIf="showDownloadUploadButtons">
        <input
          #upload
          style="display: none"
          type="file"
          id="my-file"
          (change)="onFileChange($event, false)"
          accept=".xlsx, .xls"
        />
        <button
          *ngIf="accessEdit"
          type="button"
          onclick="document.getElementById('my-file').click()"
          class="btn btn-dark"
        >
          <img
            src="./assets/images/Mask_Group_515.svg"
            alt="Upload icon"
          />
          UPLOAD
        </button>
      </div>
      <!-- <div class="p-2">
        <button type="button" class="search_btn count_btn">
          Upload
        </button>
      </div> -->
      <div class="p-2">
        <button type="button" class="search_btn count_btn" (click)="editGroups()">
          EDIT GROUPS 
        </button>
      </div>
    </div>
  </div>
  <div class="successMessage alert-dismissible">
    <div
      *ngIf="warningMessageUpload"
      class="alert alert-warning"
      role="alert"
    >
      <span class="freezedivider"
        >&nbsp;&nbsp;&nbsp;&nbsp;</span
      >
      &nbsp; &nbsp;
      <span *ngIf="warningMessageUpload"
        >{{ warningMessageUpload }}

        <a *ngIf="uploadError" class="fileName">{{ this.actualFileName }}</a>
        &nbsp;&nbsp;
        <button
          *ngIf="uploadError"
          type="button"
          class="btn btn-danger"
          (click)="getErrorReport()"
        >
          <img
            src="./assets/images/Group 115689.png"
            class="downloadIcon"
            alt="Upload icon"
          />

          ERROR REPORT
        </button></span
      >&nbsp;&nbsp;
      <button
        *ngIf="warningMessageUpload"
        type="button"
        class="btn-close"
        (click)="removeMessage()"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="card">
        <div class="container-fluid">
          <div class="row">

            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <span class="v1"></span>
                <label class="searchLable">DOCK</label>
                <p-dropdown 
                  [(ngModel)]="selectedDock" 
                  
                  (onChange)="onDockChange()"
                  [options]="dockList" 
                  [showTransitionOptions]="'0ms'" 
                  [hideTransitionOptions]="'0ms'"
                  placeholder="--Select--" 
                  [virtualScroll]="false" 
                  [itemSize]="12" 
                  autoWidth="false" 
                  [style]="{ width: '110%' }" 
                  [resetFilterOnHide]="true" 
                  optionLabel="dock" 
                  [panelStyle]="{ width: '60%' }"
                  [filter]="true"
                  appendTo="body"
                  scrollHeight="170px" 
                  [filterBy]="'dock'"
                  >
                </p-dropdown>
              </div>
            </div>
            
            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">ADDRESS </label>
                <p-dropdown 
                  [(ngModel)]="selectedGetAddress" 
                  
                  (onChange)="getAddressChange()"
                  [options]="getAddressList" 
                  [showTransitionOptions]="'0ms'" 
                  [hideTransitionOptions]="'0ms'"
                  placeholder="--Select--" 
                  [virtualScroll]="false" 
                  [itemSize]="12" 
                  autoWidth="false"
                  [style]="{ width: '110%' }" 
                  [resetFilterOnHide]="true" 
                  optionLabel="address"
                  [panelStyle]="{ width: '90%' }"
                  [filter]="true"
                  appendTo="body"
                  scrollHeight="170px" 
                  [filterBy]="'address'"
                  >
                </p-dropdown>
              </div>
            </div>

            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">KANBAN </label>
                <p-dropdown [(ngModel)]="selectedKanban" (onChange)="onKanbanChange()"
                  [options]="kanbanList" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
                  [virtualScroll]="false" [itemSize]="25" autoWidth="false" placeholder="--Select--" 
                  [style]="{ width: '110%' }" [resetFilterOnHide]="true" optionLabel="kanban"
                  [panelStyle]="{ width: '60%' }" [filter]="true"
                  appendTo="body" scrollHeight="150px" [filterBy]="'kanban'">
                </p-dropdown>
              </div>
            </div>

            <!-- <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">PART CONTROL</label>
                <p-dropdown [(ngModel)]="selectedPartsControl" (onChange)="onPartControlChange($event)"
                  [options]="partsControlList" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
                  placeholder="--Select--" [virtualScroll]="true" [itemSize]="25" autoWidth="false"
                  [style]="{ width: '100%' }" [resetFilterOnHide]="true" optionLabel="pctl_cd"
                  [panelStyle]="{ width: '110%' }"  
                  selected="false" [filter]="true" appendTo="body" scrollHeight="150px" [filterBy]="'pctl_cd'">
                </p-dropdown>
              </div>
            </div> -->
            <!-- selectedPartsControl -->
            <!-- partsControlList -->
            <!-- onPartControlChange -->
            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">SPECIALIST</label>
                <p-dropdown [(ngModel)]="selectedSpecialist" (onChange)="onSpecialistChange()"
                  [options]="specialistList" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
                  placeholder="--Select--" [virtualScroll]="false" [itemSize]="12" autoWidth="false"
                  [style]="{ width: '110%' }" [resetFilterOnHide]="true" optionLabel="employee"
                  [panelStyle]="{ width: '60%' }" [filter]="true" appendTo="body" scrollHeight="160px" [filterBy]="'employee'">
                </p-dropdown>
              </div>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">GROUP </label>
                <p-dropdown [(ngModel)]="selectedGetGroupName" (onChange)="getGetGroupNameChange()"
                  [options]="getGroupName" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
                  placeholder="--Select--" [virtualScroll]="false" [itemSize]="25" autoWidth="false"
                  [style]="{ width: '110%' }" [resetFilterOnHide]="true" optionLabel="group_name" 
                  [panelStyle]="{ width: '120%' }" [filter]="true" appendTo="body" scrollHeight="150px" [filterBy]="'group_name'">
                </p-dropdown>
                <!-- selectedGetAddres -->

                <!-- <p-multiSelect [(ngModel)]="selectedSpecialist" (onChange)="specialistChange()"
                  [options]="specialistList" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
                  [defaultLabel]="'--Select--'" [virtualScroll]="true" [itemSize]="25" autoWidth="false"
                  [style]="{ width: '100%' }" [resetFilterOnHide]="true" optionLabel="EMPLOYEE"
                  [panelStyle]="{ width: '140%' }">
                </p-multiSelect> -->
              </div>
            </div>
            

            <div class="col-xl-1 col-md-2 col-sm-3 reset_btn">
              <label class="resetIcon" (click)="onResetDropDown()">
                <img src="./assets/images/Group 115380.png" alt="refresh icon" />
              </label>
              <label class="resetlabel" (click)="onResetDropDown()">Reset</label>
              <span class="vertical"></span>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3 search">
              <button class="search_btn" (click)="onSearch(0,true)">
                SEARCH
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid"  *ngIf="showDefaultButton">
    <div class="row">
      <div class="card">
        <div class="container-fluid">
          <div class="row">

            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <!-- <span class="v1"></span> -->
                <label class="searchLable">NEXT RENBAN</label>
                <p-dropdown 
                  [(ngModel)]="selectedContainer"                   
                  (onChange)="onContainerChange()"
                  [options]="containerList" 
                  [showTransitionOptions]="'0ms'" 
                  [hideTransitionOptions]="'0ms'"
                  placeholder="--Select--" 
                  [virtualScroll]="false" 
                  [itemSize]="12" 
                  autoWidth="false" 
                  [style]="{ width: '110%' }" 
                  [resetFilterOnHide]="true" 
                  optionLabel="container_renban" 
                  [panelStyle]="{ width: '75%' }"
                  [filter]="true"
                  appendTo="body"
                  scrollHeight="170px" 
                  [filterBy]="'container_renban'"
                  >
                </p-dropdown>
              </div>
            </div>
            
            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">MODULE</label>
                <p-dropdown 
                  (onChange)="onModuleChange()"
                  [(ngModel)]="selectedModule"                   
                  [options]="moduleList" 
                  [showTransitionOptions]="'0ms'" 
                  [hideTransitionOptions]="'0ms'"
                  placeholder="--Select--" 
                  [virtualScroll]="true" 
                  [itemSize]="12" 
                  autoWidth="false"
                  [style]="{ width: '110%' }" 
                  [resetFilterOnHide]="true" 
                  optionLabel="module_number"
                  [panelStyle]="{ width: '75%' }"
                  [filter]="true"
                  appendTo="body"
                  scrollHeight="170px" 
                  [filterBy]="'module_number'"
                  >
                </p-dropdown>
              </div>
            </div>

            <!-- <div class="col-xl-1 col-md-2 col-sm-3 reset_btn">
              <label class="resetIcon" (click)="onResetDropDown()">
                <img src="./assets/images/Group 115380.png" alt="refresh icon" />
              </label>
              <label class="resetlabel" (click)="onResetDropDown()">Reset</label>
              <span class="vertical"></span>
            </div> -->
            <div class="col-xl-1 col-md-2 col-sm-3 search reset_btn" style="margin-top: 0.3rem; margin-left: 1rem;">
              <button class="search_btn" (click)="onDefault()">
                Default
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-4">
        <img *ngIf="accessEdit" src="./assets/images/edit.svg" (click)="onEditMode()"  alt="edit button icon" title="Edit" class="img-tool">
        <img
          class="img-tool"
          src="./assets/images/download.svg"
          alt="download icon"
          title="Download"
          (click)="exportAsXLSX()"
        />
        <button type="button" class="btn custom-red-button me-1" (click)="pcAddressExportToPDF()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer-fill"
            viewBox="0 0 16 16">
            <path
              d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1">
            </path>
            <path
              d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1">
            </path>
          </svg>
          <span class="button-text" style="margin-left: 3px;">PC</span>
        </button>
        <button type="button" class="btn custom-red-button me-1" (click)="prepareAndExportLSKanban()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer-fill"
            viewBox="0 0 16 16">
            <path
              d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1">
            </path>
            <path
              d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1">
            </path>
          </svg>
          <span class="button-text" style="margin-left: 3px;">LS</span>
        </button>
        <button type="button" class="btn custom-red-button me-1" (click)="prepareAndExportLS()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer-fill"
            viewBox="0 0 16 16">
            <path
              d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1">
            </path>
            <path
              d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1">
            </path>
          </svg>
          <span class="button-text" style="margin-left: 3px;">LS/Kanban</span>
        </button>
        <button type="button" class="btn custom-red-button me-1" (click)="pcLsAddressExportToPrint()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer-fill"
            viewBox="0 0 16 16">
            <path
              d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1">
            </path>
            <path
              d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1">
            </path>
          </svg>
          <span class="button-text" style="margin-left: 3px;">PC & LS</span>
        </button>
      </div>
      <div class="col-sm-4">
        <div class="records">
        </div>
      </div>

      <div class="col-sm-4">
        <div class="records" style="margin-bottom: 4px;">
          <label class="page-drpdwn-label">RECORDS / PAGE:</label>
          <select class="page-drpdwn" (change)="onPageSizeChanged()" [(ngModel)]="paginationPageSize">
            <option value="10" selected>10</option>
            <option value="30">30</option>
            <option value="50">50</option>
            <option value="{{ rowData.length }}">All</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <div id="dvgrid" class="gridStyle">
    <ag-grid-angular class="table-outer" #osPartsGrid style="width: 100%; margin-bottom: 5%;" class="ag-theme-balham"
      [columnDefs]="columnDefs" [rowData]="rowData" [rowSelection]="rowSelection" [gridOptions]="gridOptions"
      [pagination]="true" [paginationPageSize]="paginationPageSize" [context]="context"
      [suppressClickEdit]="suppressClickEdit" [frameworkComponents]="frameworkComponents"
      [tooltipShowDelay]="tooltipShowDelay" [defaultColDef]="defaultColDef"
      [masterDetail]="true" [detailRowAutoHeight]="true" (cellKeyDown)="onCellKeyDown($event)"
      [detailCellRendererParams]="detailCellRendererParams" [tooltipMouseTrack]="true" [editType]="editType">
    </ag-grid-angular>
  </div>
  <br/>
  <br/>
  <div *ngIf="isEditMode" class="saveCancel">
    <button
      matRipple
      [matRippleCentered]="true"
      [matRippleUnbounded]="false"
      class="review_btn"
      (click)="edit()"
    >
      Save Changes
    </button>
    <button (click)="cancelEdit()" class="cancel_btn">Cancel</button>
  </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading... Please wait...</p>
</ngx-spinner>